// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper {
  display: flex;
  align-items: center;
  padding: 1.5rem 0;
  position: relative;
}
.stepper__line {
  flex-grow: 1;
  height: 5px;
  background-color: #D9D9D9;
  margin-left: -4px;
  margin-right: -4px;
}
@media all and (min-width: 1280px) {
  .stepper__line {
    height: 10px;
  }
}
.stepper__line--passed {
  background-image: repeating-linear-gradient(-45deg, #D62B1F 0px 2px, #fbfbfb 3px 5px);
}
.stepper__dot {
  width: 10px;
  height: 10px;
  background-color: #D9D9D9;
  border: 1px solid #fbfbfb;
  border-radius: 50%;
  z-index: 2;
}
@media all and (min-width: 1280px) {
  .stepper__dot {
    width: 1rem;
    height: 1rem;
  }
}
.stepper__dot--current {
  background-color: #D62B1F;
  box-shadow: 0px 0px 4px 0px #fbfbfb;
}`, "",{"version":3,"sources":["webpack://./src/components/Stepper/Stepper.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AADF;AAGE;EACE,YAAA;EACA,WAAA;EACA,yBCIoB;EDFpB,iBAAA;EACA,kBAAA;AAFJ;AAII;EARF;IASI,YAAA;EADJ;AACF;AAGI;EACE,qFAAA;AADN;AAKE;EACE,WAAA;EACA,YAAA;EACA,yBCboB;EDcpB,yBAAA;EACA,kBAAA;EACA,UAAA;AAHJ;AAKI;EARF;IASI,WAAA;IACA,YAAA;EAFJ;AACF;AAII;EACE,yBCzBa;ED0Bb,mCAAA;AAFN","sourcesContent":["@import 'src/styles/variables';\n\n.stepper {\n  display: flex;\n  align-items: center;\n  padding: 1.5rem 0;\n  position: relative;\n\n  &__line {\n    flex-grow: 1;\n    height: 5px;\n    background-color: $progress-dot-disabled;\n    //width: calc(100% + 4px);\n    margin-left: -4px;\n    margin-right: -4px;\n\n    @media all and (min-width: $desktop) {\n      height: 10px;\n    }\n\n    &--passed {\n      background-image: repeating-linear-gradient(-45deg, #D62B1F 0px 2px, #fbfbfb 3px 5px);\n    }\n  }\n\n  &__dot {\n    width: 10px;\n    height: 10px;\n    background-color: $progress-dot-disabled;\n    border: 1px solid $white-100;\n    border-radius: 50%;\n    z-index: 2;\n\n    @media all and (min-width: $desktop) {\n      width: 1rem;\n      height: 1rem;\n    }\n\n    &--current {\n      background-color: $progress-bar-red;\n      box-shadow: 0px 0px 4px 0px $white-100;\n    }\n  }\n}","$headerHeightMobile: 60px;\n$headerHeightDesktop: 80px;\n\n$desktop: 1280px;\n\n\n// accents\n$main-blue-gradient: #100;\n$main-dark-blue: #1F106D;\n$main-mid-blue-100: #1F48B1FF;\n$main-mid-blue-50: #1F48B180;\n$main-light-blue: #A1C7FF;\n$hover-main-blue: #331CAA;\n$pressed-main-blue: #011C5A;\n$progress-bar-red: #D62B1F;\n$progress-dot-disabled: #D9D9D9;\n\n// brands\n$alfa-bank: #EF3124;\n$vsk: #4544EE;\n$h: #2078FE;\n$vtb: #002882;\n$robo-finance: #00BF6E;\n$x-5: #5FAF2D;\n$sport-master: #1551E5;\n\n// black\n$black-100: #151515FF;\n$black-75: #151515BF;\n$black-50: #15151580;\n$black-25: #15151540;\n\n// white\n$white-100: #FBFBFBFF;\n$white-75: #FBFBFBBF;\n$white-50: #FBFBFB80;\n$white-25: #FBFBFB40;\n\n// input\n$input-background: #F1F5F9;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
